import React from "react";
import OnboardingDrawer from "./OnboardingDrawer";

const SampleDocumentModal = ({
    isOpen,
    onClose,
    title,
    tabs,
    activeTab,
    onTabChange,
    documentSrc,
}) => {
    return (
        <OnboardingDrawer isOpen={isOpen} onClose={onClose} ariaLabel={title}>
                {/* Modal Header */}
                <div className="flex justify-between items-center p-4 ">
                    <h2 className="text-lg font-semibold">{title}</h2>
                    <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        ✕
                    </button>
                </div>

                {/* Tabs */}
                <div className="flex space-x-3 px-4 py-2 flex-wrap">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => onTabChange(tab)}
                            className={`px-4 py-2 text-sm font-medium ${
                                activeTab === tab
                                    ? "bg-[#EBE4FF] text-[#6F00FF] rounded-lg"
                                    : "text-gray-600"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Document Preview */}
                <div className="p-4">
                    {documentSrc ? (
                        <img src={documentSrc} alt={title} className="w-full h-auto rounded-lg" />
                    ) : (
                        <p className="text-gray-500 text-center">No document available</p>
                    )}
                </div>
        </OnboardingDrawer>
    );
};

export default SampleDocumentModal;
